import {name, year} from "../Constant";

function Footer(props) {
    return (
      <>
    
      
<footer> 
        <div className={props.classX? props.classX : ''}>
          &copy; Copyright {year} <b><a href="/">{name}</a></b>. &reg; All Rights Reserved.
        </div>
        </footer>
        </>
)
}

export default Footer;